'use client';

import { useTranslations } from 'next-intl';
import { CatButton } from 'components/blocks-components';

const DiscontinuedButton = () => {
  const t = useTranslations();
  return <CatButton disabled>{t('DISCONTINUED_CTA')}</CatButton>;
};
export default DiscontinuedButton;
